import { Box, Typography } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useEffect } from "react";
import GlassCard from "./GlassCard";

export default function Certificates(props) {
  const isMobile = useMediaQuery("(max-width: 700px)");

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "//cdn.credly.com/assets/utilities/embed.js";
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const badges = [
    {
      id: "6b23f308-494f-42b8-803e-929479c21454",
      label: "AWS Certified Cloud Practitioner",
    },
    {
      id: "92facef8-9069-42ca-a624-7cfc80ce4a18",
      label: "Certificate of Completion",
    },
  ];

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
      <Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 1.5,
          }}
        >
          <Box
            sx={{
              width: 4,
              height: 24,
              background: "#FF83A8",
              borderRadius: "2px",
              flexShrink: 0,
            }}
          />
          <Typography
            component="h5"
            variant="h5"
            color="secondary"
            sx={{ fontFamily: "Roboto", fontWeight: 700 }}
          >
            Certificates
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 3,
          justifyContent: "center",
        }}
      >
        {badges.map((badge) => (
          <GlassCard
            key={badge.id}
            sx={{
              padding: "20px",
              display: "inline-flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 1.5,
            }}
          >
            <Box
              sx={{
                "& > div": { display: "block !important" },
              }}
            >
              <div
                data-iframe-width={isMobile ? "200" : "340"}
                data-iframe-height="270"
                data-share-badge-id={badge.id}
                data-share-badge-host="https://www.credly.com"
              />
            </Box>
          </GlassCard>
        ))}
      </Box>
    </Box>
  );
}
